import { useEffect, useState } from 'react'

import classNames from 'classnames'
import { Pagination } from 'flowbite-react'

interface IPaginationItemProps {
  totalPages: number
  totalItems?: number
  pageSize?: number
  onPageChange: (page: number) => void
  children?: React.ReactNode
  forceDisplay?: boolean
}

const PaginationItem = ({
  totalPages,
  onPageChange,
  totalItems,
  children,
  pageSize,
  forceDisplay
}: IPaginationItemProps) => {
  const [currentPage, setCurrentPage] = useState(1)
  const handlePageChange = (page: number) => {
    setCurrentPage(page)
    onPageChange(page)
  }

  useEffect(() => {
    pageSize > 1 && setCurrentPage(1)
  }, [pageSize])

  return (
    <div className='flex justify-between items-end w-full mt-6'>
      {totalItems && (forceDisplay || totalPages > 1) ? (
        <div className='flex gap-3 justify-start items-center'>
          <span className='text-gray-800 text-sm text-normal'>
            Página <b>{currentPage}</b> de <b>{totalPages}</b>
          </span>
          {children && (
            <div className='flex justify-center items-center gap-3'>
              <span className='text-gray-800 text-sm text-normal'>
                {' '}
                exibindo:{' '}
              </span>
              {children}
              <span className='text-gray-800 text-sm text-normal'>itens </span>
            </div>
          )}
        </div>
      ) : (
        <></>
      )}
      <Pagination
        className={classNames(
          'flex justify-center items-center',
          totalPages < 2 ? 'hidden' : 'block'
        )}
        currentPage={currentPage}
        nextLabel=''
        theme={{
          pages: {
            selector: {
              active: 'bg-pagination transition-all'
            }
          }
        }}
        previousLabel=''
        onPageChange={page => handlePageChange(page)}
        showIcons
        totalPages={isNaN(totalPages) ? 0 : totalPages}
      />
    </div>
  )
}

export default PaginationItem
